<template>
<div>
  <div v-if="visible" class="loading">
    <Loading/>
  </div>
  <div :class="{'disable-page': visible }"></div>
</div>
</template>
<script>
import Loading from 'src/components/LoadingPanel';

export default {
  name: "loader",
  components: {
    Loading
  },
  computed: {
      visible() {
        return this.$loaderApp.state.loading
      } 
  },
  mounted() {
    this.$loaderApp.addRequest();
    document.onreadystatechange = () => {
      if (document.readyState == "complete") { 
        this.$loaderApp.completeRequest();
      } 
    }
  }
};
</script>

<style lang="scss">
.disable-page {
    position: fixed;
    z-index: 1050;
    opacity: .3;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(0, 0, 0);
    background-color: rgba(82, 81, 81, 0.445);
    
}
.loading{
  margin-top: -15px;
    margin-left: -35px;
        position: fixed!important;
    z-index: 1050;
    top: 50%;
    left: 50%;
}



</style>